"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m13.283 11.224.014.198a5.47 5.47 0 0 1-.25 1.93 8.464 8.464 0 0 1-.759 1.721c-.023.042-.022.07.002.111.43.752-.067 1.718-.929 1.809a1.222 1.222 0 0 1-1.354-1.298 1.225 1.225 0 0 1 1.324-1.13c.035.003.054-.003.072-.035.354-.633.643-1.291.781-2.008.167-.857.08-1.681-.329-2.463-.026-.05-.055-.066-.11-.066-.45.002-.902-.005-1.353.004a.37.37 0 0 1-.39-.388c.009-.455.002-.91.004-1.366 0-.044-.01-.07-.052-.092a3.57 3.57 0 0 0-1.973-.403c-.643.049-1.249.238-1.831.505-.225.102-.44.223-.662.333-.043.022-.055.048-.053.096.02.543-.206.951-.694 1.192-.728.36-1.607-.11-1.726-.912a1.214 1.214 0 0 1 .94-1.378 1.18 1.18 0 0 1 .867.13c.036.021.062.022.099 0 .65-.369 1.33-.67 2.058-.852a5.293 5.293 0 0 1 1.748-.149l.049.003c-.019-.02-.03-.035-.043-.048L7.478 5.411c-.032-.032-.058-.037-.1-.024a1.218 1.218 0 0 1-1.564-1.002 1.22 1.22 0 1 1 2.377.186c-.015.048-.008.076.027.111.943.941 1.885 1.883 2.825 2.825a.144.144 0 0 0 .114.048c.303-.002.607-.001.91 0 .24 0 .38.14.38.38v.91c0 .045.01.077.043.109.944.942 1.887 1.885 2.83 2.83.033.034.06.04.106.027a1.218 1.218 0 0 1 1.557 1.36 1.218 1.218 0 0 1-2.412-.025 1.29 1.29 0 0 1 .042-.534c.006-.023 0-.062-.016-.078l-1.287-1.29-.027-.02Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SvgFileIcon20.js.map